import { render, staticRenderFns } from "./FuturesOperationsDetailsTable.vue?vue&type=template&id=87124538&scoped=true&"
import script from "./FuturesOperationsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./FuturesOperationsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./FuturesOperationsDetailsTable.vue?vue&type=style&index=0&id=87124538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87124538",
  null
  
)

export default component.exports